import moment from 'moment'
const getOpenHoursOptions = (
  startTime = '03:00:00',
  step = 15,
): TOptionType[] => {
  const options = []
  for (let i = 0; i < 1440 / step; i++) {
    options.push({
      value: moment(startTime, 'HH:mm:ss')
        .add(15 * i, 'minutes')
        .format('HH:mm:ss'),
      label: moment(startTime, 'HH:mm:ss')
        .add(15 * i, 'minutes')
        .format('h:mm A'),
    })
  }
  return options
}
export const OPEN_HOURS_OPTIONS = getOpenHoursOptions('03:00:00')

export const getTimeOptions = (
  startTime = '03:00:00',
  endTime = '24:00:00',
  step = 15,
): TOptionType[] => {
  const options = []

  for (let i = 0; i < 1440 / step; i++) {
    const value = moment(startTime, 'HH:mm:ss')
      .add(step * i, 'minutes')
      .format('HH:mm:ss')
    const label = moment(startTime, 'HH:mm:ss')
      .add(step * i, 'minutes')
      .format('h:mm A')
    if (moment(value, 'HH:mm:ss').isAfter(moment(endTime, 'HH:mm:ss'))) {
      break
    }
    options.push({
      value,
      label,
    })
  }
  return options
}
